export const MODAL_TYPES = {
  DELETE: "DELETE",
  REFUSE: "REFUSE",
  COMMENT: "COMMENT",
  DOCUMENT: "DOCUMENT",
  VIEW_DOCUMENTS: "VIEW_DOCUMENTS"
};
